import { Box, Spacer } from "@chakra-ui/react";
import { FC } from "react";
import SearchInput from "../search-input";

interface LogosTableSearchProps {
    handleSearch: any
}

const LogosTableSearch: FC<LogosTableSearchProps> = ({ handleSearch }) => {
    return (
        <Box>
            <Box mb={2}>
                <SearchInput handleSearch={handleSearch} />
            </Box>
            <Spacer />
        </Box >
    );
};

export default LogosTableSearch;